export default {"src":"/_next/static/media/AssetProDark.663182a4.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};